import DeliveryData from '@type/sorr2025/DeliveryData';
import createImage from '@functions/sorr2025/createImage/createImage';
import Chart from 'chart.js/auto';
import deliveryChartConfig from '@functions/sorr2025/chartConfigs/deliveryChartConfig';

declare global {
    interface Window {
        deliveryValue: {
            label: string;
            value: number;
        }[];
    }
}

const initializeSocialChart = () => {
    const deliveryCanvas = document.getElementById('chart-delivery') as HTMLCanvasElement;

    const deliveryIcons = [
        {
            label: 'DoorDash',
            background: 'rgb(255,48,8)',
            logo: createImage('doordash.svg'),
        },
        {
            label: 'Uber Eats',
            background: 'rgb(6,193,103)',
            logo: createImage('uber-eats.svg'),
        },
        {
            label: 'Grubhub',
            background: 'rgb(255,128,0)',
            logo: createImage('grubhub.svg'),
        },
        {
            label: 'Postmates',
            background: 'rgb(0,0,0)',
            logo: createImage('postmates.svg'),
        },
    ];

    const deliveryData: DeliveryData[] = deliveryIcons.map((i) => {
        const matched = window.deliveryValue.find((j) => j.label === i.label);
        return {
            ...i,
            value: matched ? matched.value : null,
        };
    });

    const chartLabels = deliveryData.map((entry) => entry.label);
    const chartData = deliveryData.map((entry) => entry.value);
    const chartColors = deliveryData.map((entry) => entry.background);

    let deliveryChart = new Chart(
        deliveryCanvas,
        deliveryChartConfig({ data: deliveryData, chartLabels, chartData, chartColors })
    );

    let isLargeScreen = window.innerWidth >= 1440;

    const reinitializeChart = () => {
        deliveryChart.destroy();
        deliveryChart = new Chart(
            deliveryCanvas,
            deliveryChartConfig({ data: deliveryData, chartLabels, chartData, chartColors })
        );
    };

    window.addEventListener('resize', () => {
        const currentScreenSize = window.innerWidth >= 1440;
        if (currentScreenSize !== isLargeScreen) {
            isLargeScreen = currentScreenSize;
            reinitializeChart();
        }
    });
};

export default initializeSocialChart;
